import API from "./api";

/**
 * アクセスログAPI ログ出力
 */
export const postAccessLog = async (loginuserId: number, contentsPath: string) => {
  return await API.post("/cms-api/accessLog", { loginuser_id: loginuserId, contents_path: contentsPath })
};